import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { News, NewsDto } from '../models';
import { map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getNews(): Observable<News[]> {
        return this.httpClient.get<NewsDto[]>('api/v1/library/news').pipe(map((response) => response.map((item) => new News(item))));
    }
}
